import { IUSBConnectedPen } from "@neolab-libs/nl-lib3-common/interfaces/IUSBConnectedPen";
import { PenStudentInfo } from "../Bluetooth/PenStudentInfo";


export enum USBPenDataInquiryStatus {
    idle = 0,
    readingOfflineFile = 1,
    error = 2,

    dataInRange = 3,
    dataNotInRange = 4,

    uploadCompleted = 5,
    //deletingRangedFile = 201
}

export type USBBatchRowState = IUSBConnectedPen & {
    studentInfo: PenStudentInfo,
    inquiryStatus: USBPenDataInquiryStatus,
    // checked: boolean,
};


export interface USBCompareDialogParams {
    deviceId: string;
    fileNames: string[];
}
